import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  min-height: 0;
`;

export const CardInfo = styled.div`
  display: flex;
  flex-direction: column;
  padding: 8px 10px;
  flex-shrink: 0;
  min-width: 0;
`;

export const ImageWrapper = styled.div`
  position: relative;
  width: 100%;
  flex: 1;
  min-height: 0;
  overflow: hidden;
`;

export const ItemImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  background: #f0f0f0;
  display: block;
`;

export const ItemName = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: #333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const MetaRow = styled.div`
  display: flex;
  gap: 4px;
  min-width: 0;
  font-size: 12px;
  line-height: 1.3;
`;

export const MetaLabel = styled.span`
  color: #6c757d;
  flex-shrink: 0;
`;

export const MetaValue = styled.span`
  color: #495057;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const TypeBadge = styled.span`
  position: absolute;
  top: 8px;
  left: 8px;
  z-index: 2;
  background-color: rgba(0, 0, 0, 0.55);
  color: white;
  padding: 2px 6px;
  font-size: 10px;
  font-weight: 700;
  border-radius: 4px;
  text-transform: uppercase;
  letter-spacing: 0.4px;
`;
